import cx from "clsx";
import InputV3 from "kreate-common/modules/kreate-ui/components/InputV3";
import React from "react";

import styles from "./index.module.scss";

import { ADA_SYMBOL } from "@/modules/common-utils/unicode";
import { useField$LovelaceAmount } from "@/modules/form-field/hooks/useField$LovelaceAmount";

type OwnProps = {
  className?: string;
  style?: React.CSSProperties;
  value: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  color?: "error" | "normal";
  disabled?: boolean;
};

type ForwardedProps = Omit<
  React.ComponentProps<typeof InputV3>,
  keyof OwnProps
>;

type Props = OwnProps & ForwardedProps;

export function Base({
  className,
  style,
  value,
  onChange,
  onBlur,
  color,
  disabled,
  ...others
}: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      <InputV3
        size="lg"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        autoComplete="off"
        color={color}
        disabled={disabled}
        rightAdornment={<InputV3.Adornment content={ADA_SYMBOL} />}
        alwaysShrinkLabel
        {...others}
      />
    </div>
  );
}

// Syntactic sugar to integrate with `useField$LovelaceAmount` easier
function UseField$LovelaceAmount({
  api,
  ...otherProps
}: {
  api: ReturnType<typeof useField$LovelaceAmount>;
} & Partial<Props>) {
  return (
    <Base
      value={api.draft}
      onChange={api.setDraft}
      onBlur={api.validateAfterEditing}
      color={api.error ? "error" : "normal"}
      {...otherProps}
    />
  );
}

const InputLovelaceAmount$Compact = Object.assign(Base, {
  UseField$LovelaceAmount,
});

export default InputLovelaceAmount$Compact;
